"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Key.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-crypto/ie11-detection/build/Key.js
// module id = 1664
// module chunks = 0